var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5460_2558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5051 17.5207L13.276 13.833L10.4635 19.458L8.88008 14.7082L8.07242 15.5158H2.97852C3.55241 19.0987 6.27753 24.0002 9.8907 24.0002C10.5938 24.0002 11.3016 23.8052 12.0001 23.4199C12.6985 23.8052 13.4063 24.0002 14.1095 24.0002C17.722 24.0002 20.4474 19.1008 21.0216 15.5158H16.5099L14.5051 17.5207Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.495 12.1045L10.7241 15.7922L13.5366 10.1672L15.12 14.917L15.9277 14.1094H21.1406C21.1406 10.2323 17.9864 7.07812 14.1094 7.07812C13.6439 7.07812 13.1784 7.12969 12.7031 7.23469V5.625H13.4062C16.1203 5.625 18.3281 3.41719 18.3281 0.703125V0H16.2188C14.5341 0 13.0444 0.850781 12.1575 2.145C12.1575 2.14509 12.1574 2.14523 12.1573 2.14533C11.432 0.865547 10.0575 0 8.48438 0V1.40625C10.0352 1.40625 11.2969 2.66794 11.2969 4.21875V7.23469C10.8216 7.12969 10.3561 7.07812 9.89062 7.07812C6.01359 7.07812 2.85938 10.2323 2.85938 14.1094H7.49016L9.495 12.1045Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1094V15.5156H2.97844C2.90016 15.0277 2.85937 14.5552 2.85937 14.1094H0Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1405 14.1094C21.1405 14.5552 21.0998 15.0277 21.0215 15.5156H23.9999V14.1094H21.1405Z",
    fill: "#C59C37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5460_2558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/wellness.09a6a9d96ebe173447034033619a034c.svg";
export { ForwardRef as ReactComponent };